import React, { ReactNode, useState } from 'react'
import style from './style.module.css'
import './style.css'
import 'keen-slider/keen-slider.min.css'
import cx from 'classnames'
import { useMediaQuery } from 'hooks/useMediaQuery'
import { useKeenSlider } from 'keen-slider/react'
import SliderButton from './Buttons'

type Props = {
  children: ReactNode
  slideId: string
  slidesPerView: number
  numItems: number
  arrowDisplayType?: 'boxed-right' | 'dots-beneath'
}

function Carousel({
  children,
  slideId,
  slidesPerView,
  numItems,
  arrowDisplayType,
}: Props) {
  const [currentSlide, setCurrentSlide] = useState<number>(0)
  const [maxIdx, setMaxIdx] = useState<number>(0)

  const isSmallTablet = useMediaQuery('(max-width: 480px)')

  const showArrows = numItems > 1

  const [sliderRef1, instanceRef1] = useKeenSlider<HTMLDivElement>({
    selector: `.${slideId}`,
    initial: 0,
    loop: false,
    drag: true,
    slides: {
      origin: 'auto',
      perView: slidesPerView,
      spacing: 16,
    },
    detailsChanged(slider) {
      setCurrentSlide(slider.track.details.rel)
      setMaxIdx(slider.track.details.maxIdx)
    },
  })

  return (
    <div className={style.wrapper}>
      <div
        className={cx(style.innerWrapper, {
          [style.paginationBoxedRight]: arrowDisplayType === 'boxed-right',
          [style.dotsBeneath]:
            showArrows && arrowDisplayType === 'dots-beneath',
        })}
      >
        {!isSmallTablet && showArrows ? (
          <div className={style.arrows}>
            <SliderButton
              dir='left'
              background='light'
              arrow='dark'
              variation='dots-beneath'
              disabled={currentSlide === 0}
              parent={`Cards List - ${slideId}`}
              instanceRef1={instanceRef1}
            />
            {arrowDisplayType === 'dots-beneath' ? (
              <ul className={style.dots}>
                {[...Array(numItems)].map((el, i) => (
                  <li
                    key={`dot-${i}`}
                    className={cx(style.dot, {
                      [style.currentDot]: currentSlide === i,
                    })}
                  >
                    &bull;
                  </li>
                ))}
              </ul>
            ) : null}
            <SliderButton
              dir='right'
              background='light'
              variation='dots-beneath'
              disabled={currentSlide === maxIdx}
              arrow='dark'
              parent={`Cards List - ${slideId}`}
              instanceRef1={instanceRef1}
            />
          </div>
        ) : null}
        <div className={style.sliderWrapper}>
          <div ref={sliderRef1} className={cx(style.keenSlider, 'keen-slider')}>
            {children}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Carousel
